module.exports = __webpack_public_path__ + "img/couples-088.193964a6.jpg";